import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  container: {
    maxWidth: 1000,
    margin: '0 auto',
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },
  title: {
    color: theme.colors.grey,
    fontSize: 13,
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  alertContainer: {
    width: 500,
    margin: '10px auto',
  },
  listContainer: {
    width: '50%',
    boxSizing: 'border-box',
    padding: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  permsContainer: {
    width: '50%',
    boxSizing: 'border-box',
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(8),
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      marginBottom: '80px',
    },
  },
  accessContainer: {
    marginTop: theme.spacing(2),
  },
  buttonContainer: {
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    width: '100%',
    maxWidth: 1000,
    margin: '0 auto',
    padding: theme.spacing(2),
  },
  button: {
    backgroundColor: theme.colors.darkGrey,
    marginRight: theme.spacing(2),
  },
  submit: {
    backgroundColor: theme.colors.blue,
  },
}));
